import { render, staticRenderFns } from "./entryCenter.vue?vue&type=template&id=1d58cd7d&scoped=true&"
import script from "./entryCenter.vue?vue&type=script&lang=js&"
export * from "./entryCenter.vue?vue&type=script&lang=js&"
import style0 from "./entryCenter.vue?vue&type=style&index=0&id=1d58cd7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d58cd7d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d58cd7d')) {
      api.createRecord('1d58cd7d', component.options)
    } else {
      api.reload('1d58cd7d', component.options)
    }
    module.hot.accept("./entryCenter.vue?vue&type=template&id=1d58cd7d&scoped=true&", function () {
      api.rerender('1d58cd7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insuranceCenter/entryCenter.vue"
export default component.exports